import { EntryRequest } from 'modules/teams/domain/interfaces/entry-request';
import { EntryRequestResponseDto, EntryRequestUserDto } from 'modules/teams/domain/interfaces/response-dto';
import { TeamParticipant } from 'modules/teams/domain/interfaces/team-participant';
import { USER_DEFAULT_AVATAR } from 'shared/constants/links';

export function mapEntryRequestUserDto(user: EntryRequestUserDto): TeamParticipant {
  return {
    id: user.id,
    name: user.name ?? '',
    surname: user.surname ?? '',
    middleName: user.middleName,
    birthDate: user.birthDate,
    height: user.height,
    weight: user.weight,
    photo: { id: user.photo?.id ?? 0, externalUrl: user.photo?.externalUrl ?? USER_DEFAULT_AVATAR },
    createdAt: user.createdAt ? new Date(user.createdAt) : new Date(0),
  };
}

export function mapEntryRequestDto(entryRequest: EntryRequestResponseDto): EntryRequest {
  return {
    id: entryRequest.id,
    status: entryRequest.status,
    createdAt: entryRequest.createdAt,
    user: mapEntryRequestUserDto(entryRequest.requestingUser),
  };
}
